import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";

import AdminLayout from "./AdminLayout";
import InternalAdminRouter from "./AdminRouter";
import { AdminPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const BrandIndex = lazy(() => import("./Brands"));
const NewBrand = lazy(() => import("./Brands/new"));
const ShowBrand = lazy(() => import("./Brands/show"));
const BrandDetails = lazy(() => import("./Brands/show/details/Details"));
const BrandBacklogs = lazy(() => import("./Brands/show/maintenance/backlogs/BacklogsPage"));
const BulkTaskCancellationPage = lazy(
    () => import("./Brands/show/maintenance/BulkTaskCancellation/BulkTaskCancellationPage")
);
const BrandedPhoneNumbers = lazy(() => import("./Brands/show/branded-phone-numbers"));
const CallCenterPhoneNumbers = lazy(() => import("./Brands/CallCenterFeatures/phone-numbers"));
const BusinessProfiles = lazy(() => import("./Brands/show/business-profiles"));
const VoicesIndex = lazy(() => import("./Voices"));
const TemplatesIndex = lazy(() => import("./Templates"));

export const adminRoute: RegalRouteObject = {
    path: AppPagePaths.admin,
    element: <InternalAdminRouter />,
    hasNestedRoutes: true,
    children: [
        {
            element: <AdminLayout />,
            children: [
                {
                    index: true,
                    element: <Navigate to={AdminPaths.brands} replace />,
                },
                {
                    path: AdminPaths.brands,
                    element: <BrandIndex />,
                },
                {
                    path: `${AdminPaths.brands}/${AdminPaths.newBrand}`,
                    element: <NewBrand />,
                },
                {
                    path: `${AdminPaths.brands}/${AdminPaths.editBrand}`,
                    element: <ShowBrand />,
                    children: [
                        {
                            index: true,
                            element: <Navigate to={AdminPaths.brandDetails} replace />,
                        },
                        {
                            path: AdminPaths.brandDetails,
                            element: <BrandDetails />,
                        },
                        {
                            path: AdminPaths.brandBacklogs,
                            element: <BrandBacklogs />,
                        },
                        {
                            path: `${AdminPaths.brandMaintenance}/${AdminPaths.maintenanceBulkTaskCancellation}`,
                            element: <BulkTaskCancellationPage />,
                        },
                    ],
                },
                {
                    path: `${AdminPaths.brands}/${AdminPaths.editBrand}/${AdminPaths.brandBusinessProfiles}`,
                    element: <BusinessProfiles />,
                },
                {
                    path: `${AdminPaths.brands}/${AdminPaths.editBrand}/${AdminPaths.brandBrandedPhoneNumbers}`,
                    element: <BrandedPhoneNumbers />,
                },
                {
                    path: `${AdminPaths.brands}/${AdminPaths.editBrand}/${AdminPaths.brandCallCenterPhoneNumbers}`,
                    element: <CallCenterPhoneNumbers />,
                },
                {
                    path: AdminPaths.voices,
                    element: <VoicesIndex />,
                },
                {
                    path: AdminPaths.templates,
                    element: <TemplatesIndex />,
                },
            ],
        },
    ],
};
